export const RATING_AGENCIES = ['CRISIL', 'ICRA', 'CARE', 'BRICKWORK', 'INDIARATINGS', 'ACUITE']